"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocket = useSocket;
const react_redux_1 = require("react-redux");
const react_1 = require("react");
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const user_1 = require("../store/selectors/user");
const application_host_1 = require("../common/application-host");
let retryInterval = 1000; // Initial retry interval in milliseconds
function useSocket(appUser, fbUser) {
    const socketRef = (0, react_1.useRef)();
    const socketInitialized = (0, react_1.useRef)(false);
    const [isSocketConnected, setIsSocketConnected] = (0, react_1.useState)(false);
    const userToken = (0, react_redux_1.useSelector)(user_1.selectAccessToken);
    /**
     *
     * @returns
     */
    const connectSocket = (0, react_1.useCallback)(() => {
        socketInitialized.current = true;
        const newSocket = (0, socket_io_client_1.default)(application_host_1.SOCKET_IO_URL, {
            query: { token: userToken || appUser?.token },
            transports: ["websocket"],
            reconnection: true,
            autoConnect: true,
            reconnectionDelay: 15000,
        });
        newSocket.on(`${appUser?.id}`, (message) => {
            console.log("message TEST 1 received.....", message?.type);
        });
        newSocket.on('connect_error', (error) => {
            console.error(`Connection error:user:${appUser?.id}, ERROR:`, error);
        });
        newSocket.on('error', (error) => {
            // An error occurred
            console.error('Socket.IO error:', error);
        });
        newSocket.on("connect", () => {
            console.log("connected websocket:", appUser?.id);
            setIsSocketConnected(true);
            if (application_host_1.ENV_TYPE === "dev") {
                console.log("Connection Successful!-- ", appUser?.id);
            }
        });
        newSocket.on("close", () => {
            console.log("Disconnected, attempting to reconnect...");
            setTimeout(connectSocket, retryInterval);
            retryInterval *= 2; // Exponentially increase the retry interva
        });
        socketRef.current = newSocket;
        return newSocket;
    }, [userToken, appUser]);
    // 
    const closeSocket = (0, react_1.useCallback)(() => {
        if (socketRef.current) {
            setIsSocketConnected(false);
            socketRef.current.close();
        }
        socketInitialized.current = false;
        setIsSocketConnected(false);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!appUser?.id || socketInitialized.current) {
            console.log('Socket already working...', socketInitialized.current);
        }
        else {
            const newSocket = connectSocket();
            console.log('Init socket.....', application_host_1.SOCKET_IO_URL);
        }
        return () => {
            console.log('Close socket.....');
            closeSocket();
            // setIsSocketConnected(false);
            // newSocket?.close()
        };
    }, [appUser?.id, connectSocket, closeSocket]);
    return { socketRef, closeSocket, isSocketConnected };
}
